// Use the bikeData variable from bike-data.js
const data = bikeData;

const brandDropdown = document.getElementById("brand");
const modelDropdown = document.getElementById("model");
const yearDropdown = document.getElementById("year");

// Populate Brand Dropdown
for (const brand in data) {
  const option = document.createElement("option");
  option.value = brand;
  option.textContent = brand;
  brandDropdown.appendChild(option);
}

// Handle Brand Selection
brandDropdown.addEventListener("change", function () {
  const selectedBrand = this.value;
  modelDropdown.innerHTML = '<option value="">Select Model</option>';
  yearDropdown.innerHTML = '<option value="">Select Year</option>';
  modelDropdown.disabled = true;
  yearDropdown.disabled = true;

  if (data[selectedBrand]) {
    modelDropdown.disabled = false;
    for (const model in data[selectedBrand]) {
      const option = document.createElement("option");
      option.value = model;
      option.textContent = model;
      modelDropdown.appendChild(option);
    }
  }
});

// Handle Model Selection
modelDropdown.addEventListener("change", function () {
  const selectedBrand = brandDropdown.value;
  const selectedModel = this.value;
  yearDropdown.innerHTML = '<option value="">Select Year</option>';
  yearDropdown.disabled = true;

  if (data[selectedBrand]?.[selectedModel]) {
    yearDropdown.disabled = false;
    data[selectedBrand][selectedModel].forEach((year) => {
      const option = document.createElement("option");
      option.value = year;
      option.textContent = year;
      yearDropdown.appendChild(option);
    });
  }
});
